import {
  SET_ACCOUNT_DRAWER_OPEN,
  SET_PROJECTS,
  SET_APP_PROJECTS,
  SET_APP_STOPS,
  SET_PROJECTS_QUANTITY,
  RESET_ACCOUNT_STATE,
  SET_WEBHOOKS,
  SET_WEBHOOK_EVENT_TYPES,
  SET_ACTIVE_DIALOG,
  SET_BILLING_OPEN,
  SET_CURRENT_PRICING_DIALOG,
  SET_PAYMENT,
  SET_BILLING_DETAILS,
  SET_INVOICES,
  SET_TAGS,
  SET_TEMPLATES,
  SET_APPS,
  SET_API_KEYS
} from "../actions/types";

const initialState = {
  accountDrawerOpen: false,
  projects: [],
  appProjects: [],
  appStops: { data: [] },
  totalQuantity: null,
  webhooks: [],
  webhookEventTypes: [],
  accountDialog: "",
  pricingModalOpen: false,
  currentPricingDialog: "selectPlan",
  payment: null,
  billingDetails: {},
  invoices: [],
  tags: [],
  apps: [],
  sortedTags: {
    vehicleTags: [],
    driverTags: []
  },
  templates: [],
  apiKeys: []
};

export function accountReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCOUNT_DRAWER_OPEN:
      return {
        ...state,
        accountDrawerOpen: action.open
      };
    case SET_PROJECTS:
      return {
        ...state,
        projects: action.projects
      };

    case SET_APPS:
      return {
        ...state,
        apps: action.apps
      };
    case SET_APP_STOPS:
      return {
        ...state,
        appStops: action.appStops
      };
    case SET_APP_PROJECTS:
      return {
        ...state,
        appProjects: action.appProjects
      };
    case SET_PROJECTS_QUANTITY: {
      return {
        ...state,
        totalQuantity: action.quantity
      };
    }
    case RESET_ACCOUNT_STATE:
      return {
        ...initialState
      };
    case SET_WEBHOOKS:
      return {
        ...state,
        webhooks: action.webhooks
      };
    case SET_API_KEYS:
      return {
        ...state,
        apiKeys: action.apiKeys
      };
    case SET_TAGS:
      return {
        ...state,
        tags: action.tags,
        sortedTags: action.tags.reduce(
          (p, c) => {
            if (c.type === "DRIVER") {
              p.driverTags.push(c);
            } else {
              p.vehicleTags.push(c);
            }
            return p;
          },
          {
            vehicleTags: [],
            driverTags: []
          }
        )
      };
    case SET_TEMPLATES:
      return {
        ...state,
        templates: action.templates
      };
    case SET_PAYMENT:
      return {
        ...state,
        payment: action.obj
      };
    case SET_BILLING_DETAILS:
      return {
        ...state,
        billingDetails: action.obj
      };
    case SET_INVOICES:
      return {
        ...state,
        invoices: action.invoices
      };
    case SET_ACTIVE_DIALOG:
      return {
        ...state,
        accountDialog: action.dialogName
      };
    case SET_BILLING_OPEN:
      return {
        ...state,
        pricingModalOpen: action.bool
      };
    case SET_CURRENT_PRICING_DIALOG:
      return {
        ...state,
        currentPricingDialog: action.dialogName
      };
    case SET_WEBHOOK_EVENT_TYPES:
      return {
        ...state,
        webhookEventTypes: action.eventTypes
      };
    default:
      return state;
  }
}
